<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ category }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="py-0">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting Specialty details.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="py-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-data-table
            :loading="load"
            :headers="headers"
            :items="tableData"
            :search="search"
            :sort-by="['reportData.AMOUNT']"
            :sort-desc="[true]"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50, -1]
            }"
            :items-per-page="10"
            :single-expand="singleExpand"
            item-key="ID"
            show-expand
            loading-text="Loading data..."
            class="elevation-0 col-md-12 m-auto pb-1"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="px-0">
                <SpecCodes :insurance="insurance" :claimID="item.ID" />
              </td>
            </template>
            <template  v-slot:item.RELEVANT_CLAIM="{ item }">
            <v-chip color="green lighten-1" v-show="item.RELEVANT_CLAIM">{{ conditionsCode}}</v-chip>          
            </template>
            <template v-slot:item.AMOUNT="{ item }">
              {{ "$" + item.AMOUNT.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") }}
            </template>

            <template slot="footer">
              <ExportCSV
                :data="this.tableData"
                :name="
                  this.category +
                  ' - Conditions' +
                  '.csv'
                "
              >
                <v-btn color="secondary" text small class="export-button">Export to CSV</v-btn>
              </ExportCSV>
            </template>
          </v-data-table>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import ExportCSV from 'vue-json-csv';
import SpecCodes from './SpecCodes';

export default {
  name: 'ConditionsModal',
  props: ['value',
   'items',
  'category',
  'insurance',
  'patientID',
  'conditionsCode',
  'conditionsType',
  'startDate',
  'endDate'],
  components: {
    SpecCodes,
    ExportCSV,
  },
  data() {
    return {
      search: '',
      load: false,
      pagination: '',
      singleExpand: true,
      expanded: [],
      cancelSource: null,
      headers:  [
        { text: 'Claim Number', value: 'ID' },
        { text: 'Servicer Name', value: 'PROVIDER_NAME' },
        { text: 'Start Date', value: 'START_DATE' },
        { text: 'End Date', value: 'END_DATE' },
        {text: 'Contains Code', value: 'RELEVANT_CLAIM'},
        { text: 'Amount', value: 'AMOUNT' },
      ],
      dialog: false,
      loading: true,
      requestError: false,
      tableData: [],
    };
  },
  methods: {
  async getPatientClaims(){
       this.loading = true;
      this.requestError = false;
      this.claim_data = [];
    
      let url = `api/modal/conditions/codes/${this.insurance}/${this.patientID}/${this.startDate}/${this.endDate}/${this.conditionsCode}/${this.conditionsType}`
     const response = axios
        .get(url)
        .then((response) => {
          this.tableData = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.loading = false;
        });
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async patientID() {
      this.tableData = [];
      this.getPatientClaims()
    }
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
.export-button {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
